import { AxiosResponse } from 'axios';

import client from '../../lib/service/publication.service';
import {
  Establishment,
  EstablishmentResponse,
  EstablishmentsResponse,
} from './establishments.types';

type Params = {
  establishment: Establishment;
};

const ESTABLISHMENTS = `/v1/establishments`;

const COMPANIES_ESTABLISHMENTS_LIST = (companyId: string) =>
  `/v1/companies/${companyId}/establishments`;
const CURRENT_COMPANIES_ESTABLISHMENT = (
  companyId: string,
  establishmentId: string,
) => `/v1/companies/${companyId}/establishments/${establishmentId}`;

export const getCompaniesEstablishments = async (companyId: string) => {
  const response = await client.get<
    null,
    AxiosResponse<EstablishmentsResponse>
  >(COMPANIES_ESTABLISHMENTS_LIST(companyId));
  return response.data.establishments;
};

export const getEstablishments = async (params?: {
  latitude: number;
  longitude: number;
}) => {
  const response = await client.get<
    null,
    AxiosResponse<EstablishmentsResponse>
  >(ESTABLISHMENTS, { params });
  return response.data.establishments;
};

export const getCompanyEstablishment = async (
  companyId: string,
  establishmentId: string,
) => {
  const response = await client.get<null, AxiosResponse<EstablishmentResponse>>(
    CURRENT_COMPANIES_ESTABLISHMENT(companyId, establishmentId),
  );
  return response.data.establishment;
};

export const postCompaniesEstablishments = async (params: Params) => {
  const response = await client.post<
    Params,
    AxiosResponse<EstablishmentResponse>
  >(COMPANIES_ESTABLISHMENTS_LIST(params.establishment.company_id), params);
  return response.data.establishment;
};

export const putCompaniesEstablishments = async (params: Params) => {
  const response = await client.put<
    Params,
    AxiosResponse<EstablishmentResponse>
  >(
    CURRENT_COMPANIES_ESTABLISHMENT(
      params.establishment.company_id,
      params.establishment.id,
    ),
    params,
  );
  return response.data.establishment;
};
